import React from 'react';
import Header from '../../components/common/Header/Header.jsx'
import Footer from '../../components/common/Footer/Footer.jsx';
import { Outlet } from 'react-router';

const Cover = () => {
    return (
        <>        
            <div className='cover'>
                <Header></Header>
                <Outlet />
                <Footer></Footer>
            </div>        
        </>
    );
}

export default Cover;